import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { find } from 'lodash';
import { setStep } from 'redux/actions/booking';

export function StepControl() {
  const dispatch = useDispatch();
  const history = useHistory();
  const bookingStepIndex = useSelector((state) => state.booking.step);
  const steps = [
    {
      pathname: '/cart',
      name: 'Continue to Checkout',
      link: '/cart/checkout',
    },
    {
      pathname: '/cart/checkout',
      name: 'Complete Booking',
      link: '/cart/confirm',
    },
    {
      pathname: '/cart/confirm',
      name: 'Return to Homepage',
      link: '/',
    },
  ];
  const bookingStep = steps[bookingStepIndex] || steps[0];

  // Handle browser's back and forward actions
  history.listen((location) => {
    const step = find(steps, (item) => item.pathname === location.pathname);
    const index = steps.indexOf(step);
    dispatch(setStep(index));
  });

  function nextStep() {
    dispatch(setStep(bookingStep + 1));
  }

  const text = bookingStep.name;
  const url = bookingStep.link;

  return (
    <div className="text-end">
      {bookingStepIndex === 2 ? (
        <a
          className="btn btn-primary py-3 px-4 d-block d-md-inline-block text-decoration-none"
          href={url}
        >
          <i className="fas fa-arrow-left me-2" />
          {text}
        </a>
      ) : (
        <Link
          className="btn btn-primary py-3 px-4 d-block d-md-inline-block text-decoration-none"
          to={url}
          // eslint-disable-next-line react/jsx-no-bind
          onClick={nextStep}
        >
          {text} <i className="fas fa-arrow-right ms-1" />
        </Link>
      )}
    </div>
  );
}
